module.exports = __webpack_public_path__ + "img/konkurs.4a769020.jpg";